import { searchDevices as _searchDevices } from "@fuze/apis-foundry/dist/devices"

import { wrapAllResultsNoOrganization } from "./decorators"

export const searchDevices = searchParameters => wrapAllResultsNoOrganization(_searchDevices)(searchParameters)
